<template>
  <div>
    <EquipmentEditHeader v-if="isAdmin" data-cy="equipment-edit-header" />
    <EquipmentTable
      data-cy="equipment-table"
      @select="$emit('select', $event.data as Intakes)"
    />
  </div>
</template>

<script setup lang="ts">
import { provide } from "vue";
import { useIntakes } from "@/composables/equipment/intakes/intakes";
import EquipmentEditHeader from "@/components/equipment/EquipmentEditHeader.vue";
import EquipmentTable from "@/components/equipment/EquipmentTable.vue";
import type { Intakes } from "gql/api";

const props = defineProps<{
  isAdmin: boolean;
}>();

defineEmits<{
  (event: "select", data: Intakes): void;
}>();

const intakeSearch = useIntakes(props.isAdmin);

provide("equipment", intakeSearch);
</script>
